'use client';

/**
 * Feuert einmalig `scroll_depth`-Events bei 25/50/75/100 % Scroll-Tiefe.
 * Respektiert Consent (trackEvent ist selbst no-op ohne Einwilligung).
 *
 * Nützlich als Conversion-Signal für Performance-Marketing: zeigt, wie
 * weit Besucher die Landing tatsächlich lesen — und gibt Meta/TikTok ein
 * Engagement-Signal jenseits des reinen PageViews.
 */

import { useEffect } from 'react';
import { trackEvent } from './analytics';

export function useScrollDepth() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const milestones = [25, 50, 75, 100];
    const fired = new Set<number>();

    const onScroll = () => {
      const doc = document.documentElement;
      const scrollable = doc.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      const pct = Math.min(100, Math.round((window.scrollY / scrollable) * 100));
      for (const m of milestones) {
        if (pct >= m && !fired.has(m)) {
          fired.add(m);
          trackEvent('scroll_depth', { depth: m });
        }
      }
      if (fired.size === milestones.length) {
        window.removeEventListener('scroll', onScroll);
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
}
